import { render, staticRenderFns } from "./liveCourse.vue?vue&type=template&id=c11f297e&scoped=true"
import script from "./liveCourse.vue?vue&type=script&lang=ts"
export * from "./liveCourse.vue?vue&type=script&lang=ts"
import style0 from "./liveCourse.vue?vue&type=style&index=0&id=c11f297e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11f297e",
  null
  
)

export default component.exports